export default __webpack_public_path__ + "7ec997db435df9e0a3ea64021e7ac867.png";